module.exports = __webpack_public_path__ + "img/Check.6bd61816.webp";